import '../css/style.scss'
import { ua } from './modules/ua'
import Cookies from 'js-cookie'
import Swiper from 'swiper/bundle'

const klass = {
  active: 'is-active',
  fixed: 'is-fixed',
  view: 'is-view',
  selected: 'is-selected',
  hidden: 'is-hidden',
  eventNone: 'is-eventNone',
  landscape: 'is-landscape',
  current: 'is-current',
  nav: 'view-nav',
}

class App {
  constructor() {
    this.body = document.querySelector('body')
    this.init()
  }

  init() {
    this.initPages()
  }

  initPages() {
    // 全ページ共通適用
    this.body.classList.add(`is-${ua.browser()}`)
    this.body.classList.add(`is-${ua.os()}`)

    // setupYoutubeShort()

    // // ナビゲーション開閉
    // if (document.querySelector('.navTrigger')) {
    //   document.querySelector('.navTrigger').addEventListener('click', () => {
    //     this.body.classList.toggle(klass.nav)
    //   })
    // }
    //
    // // ナビゲーションを押下時に閉じる
    // Array.from(document.querySelectorAll('#gNav a')).forEach((trigger) => {
    //   trigger.addEventListener('click', () => {
    //     this.body.classList.toggle(klass.nav)
    //   })
    // })
    //

    const shopsTrigger = document.querySelector('.release__cp-btn')
    shopsTrigger.addEventListener('click', () => {
      this.body.classList.toggle('show-modal01')
    })
    const shopsTrigger2 = document.querySelector('.release__cp-btn2')
    shopsTrigger2.addEventListener('click', () => {
      this.body.classList.toggle('show-modal02')
    })
    Array.from(document.querySelectorAll('.modal-close')).forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.body.classList.remove('show-modal01')
        this.body.classList.remove('show-modal02')
      })
    })

    Array.from(document.querySelectorAll('.interview__nav button')).forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const targetID = trigger.getAttribute('data-id')
        document.querySelector('.interview-item.is-current').classList.remove('is-current')
        document.querySelector(targetID).classList.add('is-current')

        const targetElement = document.querySelector('#interview')
        const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top
        window.scrollTo({
          top: targetOffsetTop - 30,
          behavior: 'smooth',
        })
      })
    })

    const swiper = new Swiper('.video-swiper', {
      loop: true,
      autoplay: {
        delay: 3000,
      },
      slidesPerView: 1.2,
      spaceBetween: 10,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
        },
        1024: {
          spaceBetween: 40,
        },
      },
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.pod = new App()
})

window.addEventListener('load', () => {
  document.querySelector('body').classList.add(`is-loaded`)
})
